<template>
  <div class="bg-white pa-6">
    <div class="d-flex justify-space-between mb-6 align-center">
      <h4 class="title">{{label}}</h4>
      <div class="d-flex purple--text" v-if="filters">
        <div class="btn-graph pa-2 mr-2" :class="{'active': period == 'day'}" @click="$emit('update:period', 'day');$emit('change')">D</div>
        <div class="btn-graph pa-2 mr-2" :class="{'active': period == 'week'}" @click="$emit('update:period', 'week');$emit('change')">W</div>
        <div class="btn-graph pa-2 mr-2" :class="{'active': period == 'month'}" @click="$emit('update:period', 'month');$emit('change')">M</div>
        <div class="btn-graph pa-2 mr-2" :class="{'active': period == 'year'}" @click="$emit('update:period', 'year');$emit('change')">Y</div>
      </div>
    </div>
    <canvas ref="myChart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import Vue from "vue";
export default {
  props: {
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    chartData: {
      type: Array,
      default: () => {
        return []
      }
    },
    period: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    filters: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      let ctx = this.$refs.myChart.getContext("2d");
      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: [
            {
              label: this.label,
              data: this.chartData,
              barThickness: 6,
              backgroundColor: "#38C976"
            },
            {
              label: this.label,
              data: this.chartData,

              // Changes this dataset to become a line
              type: "line",
              borderColor: "#FDC132",
              fill: false,
              borderDash: [5, 6],
              borderWidth: 2
            }
          ],
          labels: this.labels
        },
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontColor: "#C0C7CE"
                },
                gridLines: {
                  display: false,
                  offsetGridLines: false,
                  borderDash: [5, 8]
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  fontColor: "#C0C7CE"
                },
                gridLines: {
                  offsetGridLines: false,
                  borderDash: [5, 8]
                }
              }
            ]
          }
        }
      });
    });
  }
};
</script>

<style>
.chart-card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: none !important;
  background-color: transparent;
}
.bg-white {
  background: #fff;
}
.btn-graph {
  font-size: 17px;
  line-height: 20px;
  color: #7557e5 !important;
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: normal;
  cursor: pointer;
}
.btn-graph.active {
  color: #eb67d0 !important;
  background: #f0edfb;
  border-radius: 5px;
}
.title {
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: #3d4857;
}
</style>
